import { IFieldDefinition, ValueTypes, InputTypes } from 'app/interfaces';
import { Validators } from '@angular/forms';

const fieldsMap: Map<string, IFieldDefinition> = new Map();

const TYPE_CUSTOM = 'custom';

/**
 * Il codice non è digitato: lo genera il server come slug del nome (custom_<slug>) e resta
 * immutabile, altrimenti si romperebbero le mappature Server RT già create.
 */
fieldsMap.set('label', {
	key: 'label',
	name: 'Nome',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING,
	formValidators: [ Validators.required ],
	inputHint: 'Come lo chiama l\'operatore: es. "POS Banca X", "Satispay"',
	// i metodi standard sono definiti dalla piattaforma: si abilitano, non si rinominano
	readonlyIf(record: any): boolean{
		if(!record || !record.type) return false;
		return record.type !== TYPE_CUSTOM;
	}
});

fieldsMap.set('backoffice_enabled', {
	key: 'backoffice_enabled',
	name: 'Selezionabile in back-office',
	inputType: InputTypes.TOGGLE,
	valueType: ValueTypes.NUMBER,
	inputHint: 'Se attivo l\'operatore può dichiarare questo incasso sulle prenotazioni'
});

export { fieldsMap, TYPE_CUSTOM };
